<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="createService" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.service_id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.branch ? item.branch.branch_name_th : "" }}</td>
              <td align="center">
                <v-img :src="item.icon_show" style="width: 40px ;" />
              </td>
              <td>{{ item.title_th }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>{{ item.orders }}</td>
              <td>
                <a @click="showServiceData(item.service_id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import IconPencil from "../../../components/Icon/icon-pencil";
import CircleButton from "../../../components/Button/CircleButton";
import InputTextField from "../../../components/Input/InputTextField";
import InputSearch from "../../../components/Input/InputSearch";
// eslint-disable-next-line no-unused-vars
import moment from "moment";
import Paginate from "../../../components/Layout/Paginate";
export default {
  name: "service",
  components: {Paginate, InputSearch, InputTextField, CircleButton, IconPencil },
  data() {
    return {
      title: "Service",
      headers: [
        { id: 1, text: "No." },
        { id: 3, text: "Branch" },
        { id: 4, text: "Icon" },
        { id: 5, text: "Service" },
        { id: 6, text: "Update date" },
        { id: 7, text: "Order" },
        { id: 8, text: "edit" }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    };
  },
  created() {
    this.getServiceTable();
  },
  methods: {
    goToServiceEdit() {
      this.$router.push("/service/edit");
    },
    getServiceTable() {
      this.$store.dispatch("Services/getService", 1).then(res => {
        if (res.response_code === 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    changePage(val){
      this.dataPaginate.current_page = val;
      this.$store.dispatch("Services/getService", this.dataPaginate.current_page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    createService() {
      this.$store.dispatch("Services/clearFormData").then(() => {
        this.goToServiceEdit();
      });
    },
    showServiceData(id) {
      this.$store.dispatch("Services/showService", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("Services/setFormService", res.result).then(() => {
            this.goToServiceEdit();
          });
        } else {
          alert(res.response_msg);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/table.css";
@import "../../../assets/css/variables";
.branch-data {
  background-color: transparent;
  margin: 20px;
}
</style>
